export const getPreviewPrefix = (organizationName, groupName) =>
  `${organizationName}${groupName ? '-' + groupName : ''}: `;
